/**
 * Display of a canonical hotkey (for example "Ctrl+Shift+A"). macOS shows the modifier
 * symbols with no separators (⌃⇧A); other platforms show words joined with "+".
 */
const MAC_SYMBOLS: Readonly<Record<string, string>> = {
  Ctrl: "⌃",
  Alt: "⌥",
  Shift: "⇧",
  Meta: "⌘",
};

const OTHER_NAMES: Readonly<Record<string, string>> = {
  Meta: "Win",
};

export function displayHotkey(canonical: string, isMac: boolean): string {
  const tokens = canonical.split("+");
  if (isMac) {
    return tokens.map((token) => MAC_SYMBOLS[token] ?? token).join("");
  }
  return tokens.map((token) => OTHER_NAMES[token] ?? token).join("+");
}
